export default function onLogOut(user) {
  if (typeof mParticle === 'undefined') {
    return;
  }
  const emptyIdentityRequest = {
    userIdentities: {},
  };
  mParticle.Identity.logout(emptyIdentityRequest);
}
